import React from 'react';
import { 
  FaRegThumbsUp, 
  FaThumbsUp, 
  FaRegMessage, 
  FaShareNodes,
  FaLinkedinIn,
  FaArrowRight
} from 'react-icons/fa6'; 

export function FeedCard({ post, onLike }) {
  return (
    <article className={`rounded-2xl border p-6 transition-all duration-300 group shadow-sm 
      ${post.isLinkedInPost 
        ? 'bg-slate-50/60 border-slate-200/80 hover:border-[#0077b5]/30' 
        : 'bg-white border-slate-200 hover:border-emerald-500/30 hover:shadow-md'
      }`}
    >
      
      {/* Top Meta Details */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-3">
          {post.isLinkedInPost ? (
            <div className="w-10 h-10 rounded-full bg-[#0077b5] text-white flex items-center justify-center text-lg shadow-sm">
              <FaLinkedinIn className="text-sm" />
            </div>
          ) : (
            <div className="w-10 h-10 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-100 font-bold flex items-center justify-center text-sm">
              Ω
            </div>
          )}
          <div>
            <h4 className="text-sm font-semibold tracking-wide text-slate-900">{post.author}</h4>
            <span className="text-xs text-slate-400">{post.date} &bull; {post.readTime}</span>
          </div>
        </div>
        <span className={`text-xs font-semibold px-2.5 py-1 rounded-md
          ${post.isLinkedInPost 
            ? 'bg-sky-50 text-[#0077b5]' 
            : 'bg-emerald-50 text-emerald-700'
          }`}
        >
          {post.category}
        </span>
      </div>

      {/* Body Content */}
      <h3 className={`text-xl font-bold leading-snug mb-2 transition-colors text-slate-900
        ${post.isLinkedInPost ? 'group-hover:text-[#0077b5]' : 'group-hover:text-emerald-600'}`}
      >
        {post.title}
      </h3>
      <p className="text-slate-600 text-sm leading-relaxed mb-4 whitespace-pre-line">
        {post.content}
      </p>

      {/* Conditional Media Rendering */}
      {post.image && (
        <div className="overflow-hidden rounded-xl border border-slate-100 mb-4">
          <img 
            className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-[1.01]" 
            src={post.image} 
            alt={post.title}
            loading="lazy"
          />
        </div>
      )}

      {/* Feed Interaction Ribbon */}
      <div className="flex items-center justify-between border-t border-slate-100 pt-4 mt-2">
        <div className="flex items-center gap-4">
          <button 
            onClick={() => onLike(post.id)}
            className={`flex items-center gap-2 text-xs font-medium transition-colors py-1.5 px-3 rounded-md hover:bg-slate-50 
              ${post.hasLiked 
                ? 'text-emerald-600 font-semibold' 
                : 'text-slate-500 hover:text-emerald-600'
              }`}
          >
            {post.hasLiked ? <FaThumbsUp className="w-3.5 h-3.5" /> : <FaRegThumbsUp className="w-3.5 h-3.5" />}
            <span>Like ({post.likes})</span>
          </button>
          
          <button className="flex items-center gap-2 text-xs font-medium text-slate-500 hover:text-emerald-600 transition-colors py-1.5 px-3 rounded-md hover:bg-slate-50">
            <FaRegMessage className="w-3.5 h-3.5" />
            <span>Comment</span>
          </button>
          
          <button className="flex items-center gap-2 text-xs font-medium text-slate-500 hover:text-emerald-600 transition-colors py-1.5 px-3 rounded-md hover:bg-slate-50">
            <FaShareNodes className="w-3.5 h-3.5" />
            <span>Share</span>
          </button>
        </div>

        {post.isLinkedInPost && post.linkedInUrl && (
          <a 
            href={post.linkedInUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-semibold text-[#0077b5] hover:text-[#005a8a] transition-colors flex items-center gap-1 group/link"
          >
            View Post 
            <FaArrowRight className="text-[10px] transition-transform group-hover/link:translate-x-0.5" />
          </a>
        )}
      </div>

    </article>
  );
}